var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo21(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47461 3.99023V5.25586H1.98633V3.99023H6.47461ZM2.42578 0.46875V9H0.814453V0.46875H2.42578ZM7.66992 0.46875V9H6.05859V0.46875H7.66992ZM14.9707 3.99023V5.25586H10.4824V3.99023H14.9707ZM10.9219 0.46875V9H9.31055V0.46875H10.9219ZM16.166 0.46875V9H14.5547V0.46875H16.166Z",
    fill: "url(#paint0_linear_3_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_10",
    x1: 17,
    y1: -2,
    x2: 3.47109e-7,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001AFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo21);
export default __webpack_public_path__ + "static/media/logo_2_1.58380f0fc9d1810f199ad03c5c181378.svg";
export { ForwardRef as ReactComponent };